import { singleline } from "@core/foundation/string";
import { hasValue } from "@core/foundation/types";
import { z } from "@core/zod";

import { AstGrepRuleSchema } from "./ast-grep.ts";

export const FileConditionSchema = z
  .object(
    {
      astGrep: AstGrepRuleSchema.optional(),
      changeOnly: z.boolean().default(false),
      glob: z.string().optional(),
      kind: z.literal("file"),
      regexp: z.regexp().optional(),
    },
    {
      astGrep: "The ast-grep rule the file's syntax must match.",
      changeOnly: singleline`
        Whether the condition fires on a change alone, matching the changed
        lines, rather than on a read or a change matching the whole file.
      `,
      glob: singleline`
        The picomatch glob, dotfiles included, the file's path relative to the
        repository root must match.
      `,
      kind: "The condition's kind, firing on a file read or changed.",
      regexp: "The JavaScript regexp the file's content must match.",
    },
  )
  .refine(
    ({ astGrep, glob, regexp }) =>
      hasValue(astGrep) || hasValue(glob) || hasValue(regexp),
    "A file condition requires at least one of glob, regexp, and astGrep",
  );
